import { jsx as _jsx } from "react/jsx-runtime";
import cx from '../../utils/classNames';
import styles from './ModalTitle.module.css';
const ModalTitle = (props) => {
    const { children, className } = props;
    return _jsx("h3", Object.assign({ className: cx(className, styles.root) }, { children: children }), void 0);
};
export default ModalTitle;
